import { useMemo } from 'react';

import { v4 as uidv4 } from 'uuid';

import { useWishlistLists } from '@components/Universals/WishlistModifier/useWishlistLists';
import { WISHLIST_BASE_URL } from '@constants';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import { getWindowOrigin } from '@utils/constants';

const getShareListUtmParams = (isDefaultList: boolean) =>
  `utm_source=notino-web-wishlist&utm_medium=referral&utm_campaign=wishlist_share&utm_content=${
    isDefaultList ? 'default' : 'custom'
  }`;

export const useShareList = () => {
  const generatedId = useMemo(() => uidv4(), []);
  const { shareList } = useWishlistLists();
  const { getTimeFromInit } = useTrackingContext();

  const share = async (listId: string, isDefaultList: boolean) => {
    const url = `${getWindowOrigin()}${WISHLIST_BASE_URL}/shared/${generatedId}?${getShareListUtmParams(
      isDefaultList
    )}`;

    void navigator.clipboard.writeText(url);

    await shareList({
      listId,
      sharedListId: generatedId,
    });

    dispatchTrackingEvent({
      event: 'wishlist_click',
      wishlist: {
        action: 'wishlist_shared',
        interaction: 'click',
        name: 'share',
        timing: getTimeFromInit(),
        mode: isDefaultList ? 'default' : 'custom',
      },
    });

    return {
      sharedListUrl: url,
    };
  };

  return { share };
};
